export default __webpack_public_path__ + "static/media/BaniereMobile.8e2e5ca7.svg";